export const LOGIN = "LOGIN"
export const LOGOUT = "LOGOUT"
export const REFRESH_TOKEN = "REFRESH_TOKEN"
export const STORE_ACCOUNT = "STORE_ACCOUNT"